import React from "react"
import { Box, Flex } from "rebass"
import { get } from "lodash"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import Toggle from "material-ui/Toggle"
import TextField from "material-ui/TextField"
import { SketchColorPicker } from "../../../../../components"
import { Counter } from "../counter"
import { fontFamily, textTransform, fontWeight } from "./utils"
import BoxTextAnimation from "./BoxTextAnimation"

const itemFontFamily = []
for (let i = 0; i < fontFamily.length; i++) {
  const item = fontFamily[i]
  itemFontFamily.push(
    <MenuItem value={item.id} key={i} primaryText={item.name} />
  )
}
const itemTT = []
for (let i = 0; i < textTransform.length; i++) {
  const item = textTransform[i]
  itemTT.push(<MenuItem value={item.id} key={i} primaryText={item.name} />)
}
const itemFW = []
for (let i = 0; i < fontWeight.length; i++) {
  const item = fontWeight[i]
  itemFW.push(<MenuItem value={item.id} key={i} primaryText={item.name} />)
}

const BoxText = (props) => {
  const { data, onUpdateValue } = props
  const value = get(data, "value", "")
  const sizeValue = get(data, "size", "48pt")
  const sizeMediumValue = get(data, "sizeMedium", "30pt")
  const sizeSmallValue = get(data, "sizeSmall", "20pt")
  const size = sizeValue.split("pt").join("") * 1
  const sizeMedium = sizeMediumValue.split("pt").join("") * 1
  const sizeSmall = sizeSmallValue.split("pt").join("") * 1

  const styleFont = {
    fontFamily: get(data, "family", "Rage Italic"),
    textAlign: get(data, "align", "center"),
    color: get(data, "color", "#ed747f"),
    textTransform: get(data, "textTransform", "normal"),
    fontWeight: get(data, "weight", "normal"),
    lineHeight: get(data, "lineHeight", "100%"),
    letterSpacing: get(data, "letterSpacing", 0),
  }
  const lineHeight = styleFont.lineHeight.split("%").join("") * 1
  const letterSpacing = styleFont.letterSpacing.split("px").join("") * 1

  return (
    <Box w={[1]}>
      <TextField
        fullWidth={true}
        hintText=""
        name={"value"}
        floatingLabelText={"Value"}
        value={value}
        onChange={(e) => onUpdateValue("value", e.target.value, props.index)}
      />
      <SelectField
        floatingLabelText="Font-Family"
        value={styleFont.fontFamily}
        onChange={(event, index, value) =>
          onUpdateValue("family", value, props.index)
        }
        maxHeight={200}
      >
        {itemFontFamily}
      </SelectField>
      <SelectField
        floatingLabelText="Text Transform"
        value={styleFont.textTransform}
        onChange={(event, index, value) =>
          onUpdateValue("textTransform", value, props.index)
        }
        maxHeight={200}
      >
        {itemTT}
      </SelectField>
      <SelectField
        floatingLabelText="Font-Weight"
        value={styleFont.fontWeight}
        onChange={(event, index, value) =>
          onUpdateValue("weight", value, props.index)
        }
        maxHeight={200}
      >
        {itemFW}
      </SelectField>
      <Flex
        w={[1]}
        direction={"row"}
        wrap={"wrap"}
        py={[1]}
        className="child-wrap"
      >
        <Toggle
          label="Italic"
          style={{ width: 100 }}
          toggled={data.italic}
          onToggle={(e) =>
            onUpdateValue("italic", e.target.checked, props.index)
          }
        />
        <SketchColorPicker
          title={"Color"}
          onUpdateColor={(color) => onUpdateValue("color", color, props.index)}
          color={styleFont.color}
        />
      </Flex>
      <Flex
        w={[1]}
        direction={"row"}
        wrap={"wrap"}
        py={[1]}
        className="child-wrap"
      >
        <Counter
          isDisabled={false}
          title="lineHeight"
          onSetValue={(value) =>
            onUpdateValue("lineHeight", `${value}%`, props.index)
          }
          value={lineHeight}
          interval={5}
          subtitle="%"
          minValue={100}
        />
        <Counter
          isDisabled={false}
          title="letterSpacing"
          onSetValue={(value) =>
            onUpdateValue("letterSpacing", `${value}`, props.index)
          }
          value={letterSpacing}
          interval={1}
          subtitle=""
          minValue={0}
        />
      </Flex>
      <Flex
        w={[1]}
        direction={"row"}
        wrap={"wrap"}
        py={[1]}
        className="child-wrap"
      >
        <Counter
          isDisabled={false}
          title="Font Size Desktop"
          onSetValue={(value) => onUpdateValue("size", `${value}pt`)}
          value={size}
          interval={1}
          subtitle="pt"
          minValue={5}
        />
        <Counter
          isDisabled={false}
          title="Font Size Tablet"
          onSetValue={(value) => onUpdateValue("sizeMedium", `${value}pt`)}
          value={sizeMedium}
          interval={1}
          subtitle="pt"
          minValue={5}
          style={{ marginRight: 16 }}
        />
        <Counter
          isDisabled={false}
          title="Font Size Mobile"
          onSetValue={(value) => onUpdateValue("sizeSmall", `${value}pt`)}
          value={sizeSmall}
          interval={1}
          subtitle="pt"
          minValue={5}
        />
      </Flex>
      <BoxTextAnimation {...props} />
    </Box>
  )
}
export default BoxText



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/carouselanimation/BoxText.js